<template>
  <div class="monthly-fee-log">
    <el-card class="box-card">
      <div slot="header" class="header-row">
        <span><i class="el-icon-s-data"></i> Monthly Fee Log</span>
      </div>

      <el-form :inline="true" size="small" class="toolbar">
        <el-form-item label="Year">
          <el-select v-model="selectedYear" style="width: 120px">
            <el-option
              v-for="year in yearOptions"
              :key="year"
              :label="year.toString()"
              :value="year"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="loading"
            @click="searchLog"
          >
            Search
          </el-button>
          <el-button
            type="success"
            icon="el-icon-download"
            :disabled="loading"
            @click="onExport"
          >
            Export
          </el-button>
        </el-form-item>
      </el-form>

      <div class="section-title">Monthly Charge</div>
      <el-table v-loading="loading" :data="monthlyFeeRows" border>
        <el-table-column prop="forMonth" label="For Month" width="120" />
        <el-table-column prop="type" label="Type" width="150" />
        <el-table-column prop="status" label="Status" width="120" />
        <el-table-column prop="paidDate" label="Paid Date" width="180" />
        <el-table-column prop="paidBy" label="Paid By" width="140" />
        <el-table-column prop="reference" label="Reference" min-width="220" />
      </el-table>

      <div v-if="complianceFeeRows.length > 0" class="section-title">
        Compliance Fee
      </div>
      <el-table
        v-if="complianceFeeRows.length > 0"
        v-loading="loading"
        :data="complianceFeeRows"
        border
      >
        <el-table-column prop="forMonth" label="For Month" width="120" />
        <el-table-column prop="type" label="Type" width="150" />
        <el-table-column prop="status" label="Status" width="120" />
        <el-table-column prop="paidDate" label="Paid Date" width="180" />
        <el-table-column prop="paidBy" label="Paid By" width="140" />
        <el-table-column prop="reference" label="Reference" min-width="220" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
import {
  getMonthlyFeeLog,
  exportMonthlyFeeLog,
} from "@/api/customer";


function normalizeFeeRow(row = {}) {
  return {
    forMonth: row.forMonth || "-",
    type: row.type || "-",
    status: row.status || "-",
    paidDate: row.paidDate || "-",
    paidBy: row.paidBy || "-",
    reference: row.reference || "-",
  };
}

export default {
  props: {
    bankholderID: String,
  },
  data() {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear - 5; year <= currentYear + 1; year += 1) {
      years.push(year);
    }

    return {
      selectedYear: currentYear,
      yearOptions: years,
      monthlyFeeRows: [],
      complianceFeeRows: [],
      loading: false,
    };
  },
  methods: {
    searchLog() {
      this.loading = true;
      getMonthlyFeeLog(this.bankholderID, this.selectedYear)
        .then(({ result, data }) => {
          if (!result || !data) {
            this.monthlyFeeRows = [];
            this.complianceFeeRows = [];
            return;
          }

          const monthlyFee = Array.isArray(data.monthlyFee) ? data.monthlyFee : [];
          const complianceFee = Array.isArray(data.complianceFee)
            ? data.complianceFee
            : [];

          this.monthlyFeeRows = monthlyFee.map((row) => normalizeFeeRow(row));
          this.complianceFeeRows = complianceFee.map((row) => normalizeFeeRow(row));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onExport() {
      exportMonthlyFeeLog(this.bankholderID, this.selectedYear);
    },
  },
  created() {
    this.searchLog();
  },
};
</script>

<style lang="scss">
.monthly-fee-log {
  .toolbar {
    margin-top: 14px;
  }

  .section-title {
    margin: 16px 0 8px;
    font-weight: 600;
  }
}
</style>
